import React from 'react'

const AboutSection: React.FC = () => {
  return (
    <section id="about" className="py-20" style={{ backgroundColor: 'var(--background)' }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-center lg:text-left">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{ color: 'var(--text)' }}>
              Unlocking the potential of people and technology
            </h2>
            <p className="text-lg mb-6 leading-relaxed" style={{ color: 'var(--text-muted)' }}>
              Founded to bring clarity and resilience to software systems, Code Beacon guides businesses toward intelligent, secure, and scalable digital futures—anchored in purpose, excellence, and trust.
            </p>
            <a href="mailto:hello@code-beacon.io" className="btn-primary">
              Learn More About Us
            </a>
          </div>
          
          <div className="relative">
            <div className="w-full h-80 about-card rounded-2xl flex items-center justify-center">
              <img 
                src="/images/code-beacon-icon-color-3.svg" 
                alt="Code Beacon" 
                width="160" 
                height="160" 
                className="float-animation" 
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AboutSection